/*eslint-disable*/
import React, {useEffect} from "react";

// import AuthNavbar from "../components/Navbars/AuthNavbar.js";
import IndexNavbar from "../components/Navbars/IndexNavbar.js";
import Terms from "../components/Legal/TermsAndConditions.js";

import '../assets/styles/tailwind.css';
import '../assets/styles/App.css';
import "@fontsource/montserrat";
import {useAuth} from "../components/Authentication/AuthProvider";


export default function Index() {
  const { userData } = useAuth();

  useEffect(() => {

  }, []);

  window.scrollTo(0, 0);
  document.title = "Terms of Use";
  return (
      <>
          <section>
              <IndexNavbar  />
          </section>

          <section className="relative">
              <div className="container mx-auto mb-24 mt-12 w-10/12">
                  <Terms userdata={userData} />
              </div>
          </section>
      </>
  );
}
